module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.9755/images/homepage/hero-personas/thumbnail-05.webp"